<template>
	
<div class="personal">

	<div class="personal-title">{{ section.personal.title }}</div>

	<div class="personal-icons">

		<div class="personal-icons-item" :class="{'is-active': $_.contains(highlighted, icon)}" v-for="(text, icon) in section.personal.icon" :key="icon" v-on:click="onHighlightClick(icon)">
			
			<div class="personal-icons-item-icon" :class="{['is-' + icon]: true}"></div>
			<div class="personal-icons-item-text">{{ text }}</div>
			
		</div>

	</div>

	<com-next v-if="!completed && !$isPatient" v-on:click.native="$emit('next')" class="personal-next" />

</div>

</template>

<script>

import comNext from './../common/Next'

export default {

	props: ['section', 'completed'],

	components: {
		'com-next': comNext
	},

	data: function() {

		return {
			highlighted: []
		}

	},

	methods: {

		onHighlightClick: function(key) {

			if (this.$isPatient) {

				this.$emit('info', key)
				return

			}

			if (this.$_.contains(this.highlighted, key)) {

				this.highlighted.splice(this.highlighted.indexOf(key), 1)

			} else {

				this.highlighted.push(key)

			}

		}

	}
	
}

</script>

<style scoped>

.personal {
	width: 50%;
	height: 297px;
	background-color: #ed7161;
	border-top-left-radius: 48px;
	padding: 30px;
}

.personal-title {
	color: #fff;
	font-size: 18px;
	letter-spacing: 1px;
	font-weight: 600;
	text-transform: uppercase;
	margin-bottom: 40px;
}

.personal-title:after {
	content: ' ';
	display: block;
	position: absolute;
	height: 2px;
	width: 75px;
	bottom: -10px;
	/*background-color: #F29589;*/
	background-color: #fff;
}

.personal-icons {
	display: flex;
	flex-wrap: wrap;
	padding-right: 72px;
	cursor: pointer;
}

.personal-icons-item {
	width: calc(50% - 4px);
	padding-right: 4px;
	border: 2px solid #F29589;
	border-radius: 30px;
	height: 44px;
	display: flex;
	align-items: center;
	padding: 4px 4px 4px 46px;
	margin: 0px 8px 8px 0px;
	color: #fff;
	line-height: 18px;
	font-size: 13px;
	font-weight: 600;
}

.personal-icons-item.is-active,
.personal-icons-item:hover {
	background-color: #BF6559;
}

.personal-icons-item:nth-child(even) {
	margin-right: 0px;
}

.personal-icons-item-icon {
	position: absolute;
	left: -2px;
	top: -2px;
	width: 44px;
	height: 44px;
	border-radius: 30px;
	border: 2px solid #F29589;
	background-color: #BF6559;
	background-position: 50% 50%;
	background-repeat: no-repeat;
}

.personal-icons-item-icon.is-breaks {
	background-image: url(~@/assets/aid/risk/personal/breaks.svg);
}

.personal-icons-item-icon.is-family {
	background-image: url(~@/assets/aid/risk/personal/family.svg);
}

.personal-icons-item-icon.is-hormones {
	background-image: url(~@/assets/aid/risk/personal/hormones.svg);
}

.personal-icons-item-icon.is-conditions {
	background-image: url(~@/assets/aid/risk/personal/conditions.svg);
}

.personal-icons-item-icon.is-medicines {
	background-image: url(~@/assets/aid/risk/personal/medicines.svg);
}

.personal-next {
	position: absolute;
	bottom: 15px;
	right: 120px;
}

.is-patient .personal {
	border-radius: 48px 0 0 48px;
}

.is-mobile .personal {
	width: 100% !important;
	border-radius: 32px !important;
	margin-bottom: 8px;
}

</style>